const productImages = document.querySelectorAll('#product-carousel .bg-img__img');
const cell = document.querySelector('#product-carousel');
var x = window.matchMedia("(min-width: 575.98px)")
try{
    if(cell){
        let smallerHeight= cell.clientHeight;
        if(x.matches)
        { 
            setInterval(function arrowPosition() {
                productImages.forEach(function(img){
                    const imgHeight= img.getBoundingClientRect().height;
                    if( smallerHeight>imgHeight && imgHeight>250){
                        smallerHeight=imgHeight;
                    }    
                });
                
                if(document.querySelector(".carousel-arrow--next")) document.querySelector(".carousel-arrow--next").style.top = smallerHeight/2+"px";
                if(document.querySelector(".carousel-arrow--prev")) document.querySelector(".carousel-arrow--prev").style.top = smallerHeight/2+"px";  
            }, 2000); }
    }
}
catch(e){
    console.log({ name: e.name, message: e.message });
}
   
    
